import BestDealGuaranteeBanner from '../application/banners/bestDealGuaranteeBanner';
import RealSaleBanner, {
  RealSaleBannerProps,
} from '../application/banners/realSaleBanner';
import ApprovedUsedBanner, {
  ApprovedUsedBannerProps,
} from '../application/banners/approvedUsedBanner';
import LowFinanceBanner from '../application/banners/lowFinanceBanner';
import EvGrantBanner, {
  type EvGrantBannerProps,
} from '../application/banners/evGrantBanner';
import RewardsWeekBanner, {
  RewardsWeekBannerProps,
} from '../application/banners/rewardsWeekBanner';
import SpotlightSaleBanner, {
  type SpotlightSaleBannerProps,
} from '../application/banners/spotlightSaleBanner';
import BlackFridayBanner, {
  type BlackFridayBannerProps,
} from '@components/application/banners/blackFridayBanner';

// so the tricky bit is how do we get Typescript to recognise the different props for each banner type
// first we'll define an enum for the banner templates just to avoid magic strings everywhere
export enum BannerTemplate {
  BEST_DEAL_GUARANTEE = 'best_deal_guarantee_banner',
  REWARDS_WEEK = 'rewards_week_banner',
  SPOTLIGHT_SALE = 'spotlight_sale_banner',
  LOW_FINANCE = 'low_finance_banner',
  REALSALE = 'realsale_banner',
  APPROVED_USED = 'approved_used_banner',
  BLACK_FRIDAY = 'black_friday_banner',
  USED_EV_GRANT = 'used_ev_grant_banner',
}

// and then we'll be explicit about the props for each banner type - if this template, then these props
type BannerProps =
  | ({
      template: BannerTemplate.REALSALE;
    } & RealSaleBannerProps)
  | ({
      template: BannerTemplate.APPROVED_USED;
    } & ApprovedUsedBannerProps)
  | ({
      template: BannerTemplate.SPOTLIGHT_SALE;
    } & SpotlightSaleBannerProps)
  | ({
      template: BannerTemplate.REWARDS_WEEK;
    } & RewardsWeekBannerProps)
  | ({
      template: BannerTemplate.BLACK_FRIDAY;
    } & BlackFridayBannerProps)
  | ({
      template: BannerTemplate.USED_EV_GRANT;
    } & EvGrantBannerProps)
  | {
      template:
        | BannerTemplate.LOW_FINANCE
        | BannerTemplate.BEST_DEAL_GUARANTEE
        | undefined;
    };

export type VehicleSearchBannerProps = {
  bannerProps: BannerProps;
};

function VehicleSearchBanner({ bannerProps }: VehicleSearchBannerProps) {
  switch (bannerProps.template) {
    case BannerTemplate.BEST_DEAL_GUARANTEE: {
      return <BestDealGuaranteeBanner />;
    }

    case BannerTemplate.REALSALE: {
      const { variant } = bannerProps;
      return <RealSaleBanner variant={variant} />;
    }

    case BannerTemplate.APPROVED_USED: {
      const { variant } = bannerProps;
      return <ApprovedUsedBanner variant={variant} />;
    }

    case BannerTemplate.SPOTLIGHT_SALE: {
      const { saving, variant } = bannerProps;
      return <SpotlightSaleBanner saving={saving} variant={variant} />;
    }

    case BannerTemplate.REWARDS_WEEK: {
      const { saving, variant } = bannerProps;
      return <RewardsWeekBanner saving={saving} variant={variant} />;
    }

    case BannerTemplate.BLACK_FRIDAY: {
      const { variant } = bannerProps;
      return <BlackFridayBanner variant={variant} />;
    }

    case BannerTemplate.USED_EV_GRANT: {
      const { variant } = bannerProps;
      return <EvGrantBanner variant={variant} />;
    }

    case BannerTemplate.LOW_FINANCE: {
      return <LowFinanceBanner />;
    }

    default:
      return null;
  }
}

export default VehicleSearchBanner;
